
$(document).ready(function() {

    // Interaktívne funkcie
    function initializeInteractions() {
        // Prepínanie medzi sekciami
        $('.skewed-button').on('click', function(e) {
            e.preventDefault(); // Zabráni default linku
            
            $('.skewed-button').removeClass('active');
            $(this).addClass('active');
            
            $('.calendar-section').addClass('d-none');
            
            const buttonId = $(this).attr('id');
            switch(buttonId) {
                case 'calendarBtn':
                    $('#calendarSection').removeClass('d-none');
                    break;
                case 'myReservationsBtn':
                    $('#myReservationsSection').removeClass('d-none');
                    break;
                case 'documentsBtn':
                    $('#documentsSection').removeClass('d-none');
                    break;
            }
        });

        // Request button funkcionalita
        $('.request-btn').on('click', function() {
            const email = $('.email-input').val();
            
            if (!email) {
                alert('Prosím zadajte email adresu');
                return;
            }
            
            if (!isValidEmail(email)) {
                alert('Prosím zadajte platnú email adresu');
                return;
            }
            
            $(this).prop('disabled', true).text('Odosielam...');
            
            setTimeout(() => {
                alert('Žiadosť bola úspešne odoslaná!');
                $(this).prop('disabled', false).text(venueData.reservationSections.calendar.note.submitButton);
                $('.email-input').val('');
            }, 2000);
        });

        // Submit request button
        $('.submit-request-btn').on('click', function() {
            const email = $('.email-input-field').val();
            
            if (!email) {
                alert('Prosím zadajte email adresu');
                return;
            }
            
            if (!isValidEmail(email)) {
                alert('Prosím zadajte platnú email adresu');
                return;
            }
            
            $(this).prop('disabled', true).text('Odosielam...');
            
            setTimeout(() => {
                alert('Žiadosť bola úspešne odoslaná!');
                $(this).prop('disabled', false).text('Odoslať žiadosť');
                $('.email-input-field').val('');
            }, 2000);
        });

        // Period search functionality
        $('.period-input').on('change', function() {
            filterReservationsByPeriod();
        });

        // Sorting functionality
        $('.past-sort-select').on('change', function() {
            sortReservations($(this).val());
        });

        function filterReservationsByPeriod() {
            const fromDate = $('.period-input').first().val();
            const toDate = $('.period-input').last().val();
            
            if (!fromDate || !toDate) {
                $('.reservation-card.past').show();
                return;
            }
            
            const from = new Date(fromDate);
            const to = new Date(toDate);
            
            $('.reservation-card.past').each(function() {
                const dateText = $(this).find('.reservation-date').text();
                const reservationDate = parseReservationDate(dateText);
                
                if (reservationDate >= from && reservationDate <= to) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        }

        function sortReservations(sortBy) {
            const container = $('.past-reservations-list');
            const cards = container.find('.reservation-card.past').get();
            
            cards.sort(function(a, b) {
                if (sortBy === 'date') {
                    const dateA = parseReservationDate($(a).find('.reservation-date').text());
                    const dateB = parseReservationDate($(b).find('.reservation-date').text());
                    return dateB - dateA; // Najnovšie najprv
                } else if (sortBy === 'venue') {
                    const venueA = $(a).find('.reservation-date').text();
                    const venueB = $(b).find('.reservation-date').text();
                    return venueA.localeCompare(venueB);
                }
            });
            
            container.empty().append(cards);
        }

        function parseReservationDate(dateString) {
            // Parsovanie "Utorok 27.6.2025" na Date objekt
            const parts = dateString.split(' ');
            if (parts.length >= 2) {
                const datePart = parts[1]; // "27.6.2025"
                const dateComponents = datePart.split('.');
                if (dateComponents.length === 3) {
                    const day = parseInt(dateComponents[0]);
                    const month = parseInt(dateComponents[1]) - 1; // Mesiace sú 0-indexed
                    const year = parseInt(dateComponents[2]);
                    return new Date(year, month, day);
                }
            }
            return new Date();
        }
    }

    // Helper function pre validáciu emailu
    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    // Inicializácia interakcií
    initializeInteractions();
});
